<template>
    <div class="layer_pop_wrap" v-if="open">
        <div class="layer_pop_dim" style="display: block; z-index: 1001"></div>
        <div class="layer_pop editor lg active" data-role-popup="modal_01" tabindex="0">
            <div class="pop_head">
                <h2>{{categoryToKoreaLang[editCategory]}} 사전 등록/수정 요청</h2>
                <button type="button" class="pop_close" @click="close()">닫기</button>
            </div>
            <div class="pop_cont" v-if="getIsSameDictionary">
                <ul>
                    <li>
                        <h3 class="form_tit">{{`사전 정보`}}</h3>
                        <table class="tbl_style2">
                            <thead>
                            <th>{{defaultData.displayTagName}}</th>
                            </thead>
                            <tbody>
                            <tr class="selected">
                                <td class="text-left">
                                    <span>{{ defaultData.displayTagName }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </li>
                </ul>
            </div>
            <div class="pop_cont" v-else>
                <h3 class="form_tit">
                    유사어 등록 설명
                </h3>
                <span>
                    &nbsp;&nbsp;&nbsp;* 좌측 = 연결하려는 상대의 정보, 우측 = 현재 수정 중인 정보입니다. 
                </span><br/>
                <span>
                    &nbsp;&nbsp;&nbsp;* 좌측을 공정도A, 우측을 프로토콜B 라고 가정 시 화살표를 클릭하면 아래와 같이 동작하게 됩니다.
                </span><br/>
                <span>
                    &nbsp;&nbsp;&nbsp;* 좌측 화살표를 클릭하면 공정도A에서 현재 사용 중인 표시어를 프로토콜B에 유사어로 추가하게 됩니다. 
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;프로토콜B의 경우 현재 수정 중인 정보이기 때문에 방금 추가한 유사어로 프로토콜B의 표시어도 변경할지 물어보게 됩니다.
                </span><br/>
                <span>
                    &nbsp;&nbsp;&nbsp;* 우측 화살표를 클릭하면 프로토콜B에서 현재 사용 중인 표시어를 공정도A에 유사어로 추가하게 됩니다.
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;공정도A의 경우 연결하려는 상대의 정보이고 B프로토콜에서 사용 중인 사전은 수정되지 않았기 때문에 표시어 변경을 물어보는 확인창이 나타나지 않습니다.
                </span><br/><br/>
                <span>
                    &nbsp;&nbsp;&nbsp;* ex ) 공정도C(좌)에 프로토콜D(우)를 연결하는 과정에서 장비 정보가 상이하여 연결이 불가능한 경우.
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(공정도C에서 사용 중인 장비는 XPS (UPS, IPES), 프로토콜D에서 사용 중인 장비는 XPS)
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;좌측 화살표 클릭 후 저장 : 프로토콜D에서 사용 중인 사전에 XPS (UPS, IPES)를 유사어로 추가하게 되며,
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    프로토콜D는 표시어를 XPS (UPS, IPES)로 변경 또는 XPS로 유지할 수 있습니다.
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;우측 화살표 클릭 후 저장 : 공정도C에서 사용 중인 사전에 XPS를 유사어로 추가하게 되며, 
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    프로토콜D에서 사용 중인 사전은 수정되지 않았기에 표시어가 XPS로 유지되게 됩니다.
                </span><br/>
                <ul class="column col_2">
                    <li>
                        <h3 class="form_tit">{{`${targetDictionary.target}`}}</h3>
                        <table class="tbl_style2">
                            <colgroup>
                                <col style="width: 70%;">
                            </colgroup>
                            <thead>
                            <tr>
                                <th v-if="targetDictionary.displayTagList?.length > 0">
                                    {{targetDictionary.displayTagList[0].displayTagName}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row,index) in targetDictionary.displayTagList"
                                :class="{selected : index == 0}"
                                :key="index">
                                <td class="text-left">
                                    <span>{{ row.displayTagName }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </li>
                    <li>
                        <h3 class="form_tit">{{`${correctionTargetDictionary.target}`}}</h3>
                        <table class="tbl_style2">
                            <colgroup>
                                <col style="width: 70%;">
                            </colgroup>
                            <thead>
                            <tr>
                                <th v-if="correctionTargetDictionary.displayTagList?.length > 0">
                                    {{correctionTargetDictionary.displayTagList[0].displayTagName}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row,index) in correctionTargetDictionary.displayTagList"
                                :class="{selected : index == 0}"
                                :key="index">
                                <td class="text-left">
                                    <span>{{ row.displayTagName }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </li>
                </ul>
            </div>
            <div class="pop_foot" v-if="!getIsSameDictionary">
                <button type="button" class="pop_btn icon-arrow-right" style="float: left"
                        @click="leftToRight"></button>
                <button type="button" class="pop_btn icon-arrow-left" @click="rightToLeft"></button>
            </div>
            <div class="pop_foot">
                <button type="button" class="pop_btn type2" v-if="editFlag" @click="saveDictionary">저장</button>
                <button type="button" class="pop_btn" @click="close()">닫기</button>
            </div>
        </div>
        <Loading :visible="loading" type="fixed"></Loading>
    </div>
</template>

<script>
    import CommNew from "@processEditor/CommNew";
    import {createNamespacedHelpers} from 'vuex';
    import Loading from '@common/loading.vue'

    const Dictionary = createNamespacedHelpers('Dictionary');
    export default {
        components: {
            Loading,
        },
        mixins:[CommNew],
        props: {
            forceReRender: {
                type: Number, default: 0,
            },
        },
        computed: {
            ...Dictionary.mapGetters(
                [
                    "getRegistDictionaryPopupOpenFlag"
                    , "getRegistTargetCategory"
                    , "getIsSameDictionary"
                    , "getDictionaryCheckKey"
                ]
            ),
        },
        data() {
            return {
                open: false,
                editCategory: "",
                categoryToKoreaLang: {
                    MATERIAL: "재료",
                    ANALYSIS: "분석목적",
                    MEASUREMENT: "측정목적",
                    EQUIPMENT: "장비",
                },
                processTypeToKoreaLang: {
                    NORMAL: "공정도",
                    ONLY_PROTOCOL: "프로토콜",
                },
                editData: {},
                defaultData: {},
                correctionTargetDictionary: {},
                targetDictionary: {},
                editFlag: false,
                loading: false,
            }
        },
        watch: {
            getRegistDictionaryPopupOpenFlag(value) {
                if (value) {
                    // 데이터 확인.
                    this.open = value;
                    this.init();
                } else {
                    // 데이터 초기화 
                    this.setRegistTargetCategory("");
                    this.setIsSameDictionary(false);
                    this.open = value;
                    this.callForceReRender();
                }
            },
        },
        mounted() {
        },
        methods: {
            ...Dictionary.mapMutations(
                [
                    "setRegistDictionaryPopupOpenFlag",
                    "setRegistTargetCategory",
                    "setIsSameDictionary",
                    "setDictionaryCheckKey",
                ]),
            ...Dictionary.mapActions(
                [
                    "findRegistDataByCategory",
                    "callResetLinkNodeFunc",
                ]),
            close() {
                this.setRegistDictionaryPopupOpenFlag(false);
            },
            async init() {
                this.loading = true;
                this.editCategory = this.getRegistTargetCategory; // MATERIAL ANALYSIS MEASUREMENT EQUIPMENT
                this.editData = await this.findRegistDataByCategory({category: this.getRegistTargetCategory});

                let targetDictionary = await this.$wApi.dictionary.getDictionaryByKey({
                    processId: this.editData.targetDataId,
                    key: this.editData.targetProcessNode.key,
                    tagId: this.editData.targetProcessNode.tagId,
                });
                let correctionTargetDictionary = await this.$wApi.dictionary.getDictionaryByKey({
                    processId: this.editData.correctionTargetId,
                    key: this.editData.correctionTargetProcessNode.key,
                    tagId: this.editData.correctionTargetProcessNode.tagId,
                });
                if (this.getIsSameDictionary) {
                    let temp_obj = {
                        dictionaryId: correctionTargetDictionary.id,
                        dictionaryData: correctionTargetDictionary,
                        target: `${this.processTypeToKoreaLang[this.editData.correctionTargetType]}`,
                        similarTagList: correctionTargetDictionary.similarTagList,
                        displayTagId: this.editData.correctionTargetProcessNode.tagId,
                        displayTagName: this.editData.correctionTargetProcessNode.text,
                    }
                    this.defaultData = temp_obj;
                } else {
                    this.targetDictionary = {
                        dictionaryId: targetDictionary.id,
                        dictionaryData: targetDictionary,
                        processId: this.editData.targetDataId,
                        nodeData: this.editData.targetProcessNode,
                        target: `${this.processTypeToKoreaLang[this.editData.targetDataType]}`,
                        similarTagList: targetDictionary.similarTagList,
                        displayTagList: [{
                            displayTagId: this.editData.targetProcessNode.tagId,
                            displayTagName: this.editData.targetProcessNode.text,
                        }],
                    };
                    this.correctionTargetDictionary = {
                        dictionaryId: correctionTargetDictionary.id,
                        dictionaryData: correctionTargetDictionary,
                        processId: this.editData.correctionTargetId,
                        nodeData: this.editData.correctionTargetProcessNode,
                        target: `${this.processTypeToKoreaLang[this.editData.correctionTargetType]}`,
                        similarTagList: correctionTargetDictionary.similarTagList,
                        displayTagList: [{
                            displayTagId: this.editData.correctionTargetProcessNode.tagId,
                            displayTagName: this.editData.correctionTargetProcessNode.text,
                        }],
                    };
                }

                this.loading = false;
            },
            callForceReRender() {
                this.$emit("update:forceReRender", this.$props.forceReRender + 1);
            },
            async leftToRight() {
                const msg = `"${this.targetDictionary.displayTagList[0].displayTagName}"을(를) <b>${this.correctionTargetDictionary.target}</b>의 사전에 유사어로 추가 하시겠습니까?`;
                const confirm = await window.confirm(msg);
                if (confirm) {
                    if (this.correctionTargetDictionary.displayTagList.length > 1) {
                        window.alert(`이미 추가된 데이터 입니다.`);
                        return;
                    }
                    const targetDictionaryDisplayTagList = this.targetDictionary.displayTagList;
                    if (targetDictionaryDisplayTagList.length > 1) {
                        this.targetDictionary.displayTagList.pop();
                        window.alert(`<b>${this.targetDictionary.target}</b> 사전에 유사어로 추가한 <br><b>"${this.correctionTargetDictionary.displayTagList[0].displayTagName}"</b>는 초기화 되었습니다.`);
                    }
                    const addTagObj = {
                        displayTagId: targetDictionaryDisplayTagList[0].displayTagId,
                        displayTagName: targetDictionaryDisplayTagList[0].displayTagName,
                    };
                    this.correctionTargetDictionary.displayTagList.push(addTagObj);
                    this.editFlag = true;
                }
            },
            async rightToLeft() {
                const msg = `"${this.correctionTargetDictionary.displayTagList[0].displayTagName}"을(를) <b>${this.targetDictionary.target}</b>의 사전에 유사어로 추가 하시겠습니까?`;
                const confirm = await window.confirm(msg);
                if (confirm) {
                    if (this.targetDictionary.displayTagList.length > 1) {
                        window.alert(`이미 추가된 데이터 입니다.`);
                        return;
                    }
                    const correctionTargetDictionaryDisplayTagList = this.correctionTargetDictionary.displayTagList;
                    if (correctionTargetDictionaryDisplayTagList.length > 1) {
                        this.correctionTargetDictionary.displayTagList.pop();
                        window.alert(`<b>${this.correctionTargetDictionary.target}</b> 사전에 유사어로 추가한 <br><b>"${this.targetDictionary.displayTagList[0].displayTagName}"</b>는 초기화 되었습니다.`);
                    }
                    const addTagObj = {
                        displayTagId: correctionTargetDictionaryDisplayTagList[0].displayTagId,
                        displayTagName: correctionTargetDictionaryDisplayTagList[0].displayTagName,
                    };
                    this.targetDictionary.displayTagList.push(addTagObj);
                    this.editFlag = true;
                }
            },
            async saveDictionary() {
                if (this.correctionTargetDictionary.displayTagList.length > 1) { // 이 경우에만 표시어를 변경할 수 있음
                    try {
                        const changeDisplayConfirm = `<b>표시어 변경을 클릭시 ${this.correctionTargetDictionary.target}의 표시어가 
                                                      <br/>"${this.targetDictionary.displayTagList[0].displayTagName}"로 변경 되며,
                                                      <br/>
                                                      <br/>유지를 클릭시 현재 표시어로 유지됩니다.
                                                      <b/>`;
                        const changeDisplayConfirmMainMsg = `<span>표시어</span>
                                                             <div class="tooltip_box"> 
                                                                <span class="tooltip_ico"></span>
                                                                 <div class="tooltip_txt">
                                                                    <p>표시어란 에디터 상에서
                                                                        <br/>보여지는 이름이며,
                                                                        <br/>표시어가 달라도 사전을 사용하면 정상적으로
                                                                        <br/>연결 가능합니다.
                                                                    </p>
                                                                 </div>
                                                             </div>
                                                             <span>를 변경 하시겠습니까?</span>`;
                        const changeDisplayConfirmFlag = await window.confirm(changeDisplayConfirmMainMsg, changeDisplayConfirm,{cancelTitle: "표시어변경", okTitle: "유지", cancelVariant: "warning confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",});
                        let displayTagId = null;
                        if (!changeDisplayConfirmFlag) {
                            displayTagId = this.targetDictionary.displayTagList[0].displayTagId
                        }

                        this.loading = true;
                        let requestBody = {};
                        requestBody = {
                            dictionaryId: this.correctionTargetDictionary.dictionaryId,
                            similarTagId: this.targetDictionary.displayTagList[0].displayTagId,
                            processId: this.correctionTargetDictionary.processId,
                            key: this.correctionTargetDictionary.nodeData.key,
                            tagType: this.correctionTargetDictionary.nodeData.category,
                            displayTagId: displayTagId,
                        }

                        let response = await this.$wApi.dictionary.createOrModifyDictionary(requestBody);
                        if (!response.error) {
                            this.loading = false;
                            if(response.actionType == "CREATE"){
                                window.alert("사전이 생성되었습니다.");       
                            }else if(response.actionType == "MODIFY"){
                                window.alert("완료 되었습니다.");
                            }
                            if (!changeDisplayConfirmFlag) {
                                await this.initElements();
                                await this.status.issueListStatus.reload();
                                this.callResetLinkNodeFunc();
                            }
                        }
                    } catch (e) {
                        this.loading = false;
                        window.alert("사전 생성중 오류가 발생하였습니다.");
                    } finally {
                        this.loading = false;
                        this.setDictionaryCheckKey(this.getDictionaryCheckKey + 1);
                        this.setRegistDictionaryPopupOpenFlag(false);
                    }
                } else if (this.targetDictionary.displayTagList.length > 1) { // 이 경우 표시어 유지
                    try {
                        this.loading = true;
                        let response = await this.$wApi.dictionary.createOrModifyDictionary({
                            dictionaryId: this.targetDictionary.dictionaryId,
                            similarTagId: this.correctionTargetDictionary.displayTagList[0].displayTagId,
                            processId: this.targetDictionary.processId,
                            key: this.targetDictionary.nodeData.key,
                            tagType: this.targetDictionary.nodeData.category,
                        });
                        if (!response.error) {
                            this.loading = false;
                            if(response.actionType == "CREATE"){
                                window.alert("사전이 생성되었습니다.");       
                            }else if(response.actionType == "MODIFY"){
                                window.alert("완료 되었습니다.");
                            }
                        }
                    } catch (e) {
                        this.loading = false;
                        window.alert("사전 생성중 오류가 발생하였습니다.");
                    } finally {
                        this.loading = false;
                        this.setDictionaryCheckKey(this.getDictionaryCheckKey + 1);
                        this.setRegistDictionaryPopupOpenFlag(false);
                    }
                }
            },
        }
    }
</script>